import type { WizardState } from './useWizardState'

interface Props {
  pageType: WizardState['pageType']
  onChange: (type: WizardState['pageType']) => void
}

const options: Array<{ value: WizardState['pageType']; icon: string; title: string; description: string }> = [
  {
    value: 'links',
    icon: 'link',
    title: 'Promote Links',
    description: 'Share your social profiles, websites, and important links in one place.',
  },
  {
    value: 'products',
    icon: 'storefront',
    title: 'Sell Products',
    description: 'Showcase and sell your products with a beautiful storefront.',
  },
  {
    value: 'both',
    icon: 'auto_awesome',
    title: 'Links + Products',
    description: 'Combine links and a product storefront on a single page.',
  },
]

export function WizardStepType({ pageType, onChange }: Props) {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        What do you want to create?
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
        Choose the type of bio page that fits your needs.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {options.map(opt => {
          const selected = pageType === opt.value
          return (
            <button
              key={opt.value}
              onClick={() => onChange(opt.value)}
              className={`relative p-6 rounded-xl border-2 text-left transition-all ${
                selected
                  ? 'border-[#2B6CEE] bg-blue-50/50 dark:bg-blue-900/10'
                  : 'border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/20'
              }`}
            >
              {selected && (
                <div className="absolute top-3 right-3 w-6 h-6 bg-[#2B6CEE] rounded-full flex items-center justify-center">
                  <span className="material-symbols-outlined text-white text-[14px]">check</span>
                </div>
              )}
              <span
                className={`material-symbols-outlined text-3xl mb-3 block ${
                  selected ? 'text-[#2B6CEE]' : 'text-gray-400 dark:text-gray-500'
                }`}
              >
                {opt.icon}
              </span>
              <h3 className={`font-semibold mb-1 ${selected ? 'text-[#2B6CEE]' : 'text-gray-900 dark:text-white'}`}>
                {opt.title}
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
                {opt.description}
              </p>
            </button>
          )
        })}
      </div>

      <p className="text-xs text-gray-400 dark:text-gray-500 mt-6 text-center">
        Not sure? You can change this later.
      </p>
    </div>
  )
}
